import IconButtonMui from '@mui/material/IconButton'
import TextFieldMui from '@mui/material/TextField'
import FormHelperTextMui from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'

export const IconButton = styled(IconButtonMui)({
  color: '#000',
  'svg': {
    width: 20,
    height: 20,
  },
})

export const TextField = styled(TextFieldMui)({
  '.MuiInputAdornment-positionStart .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
  '.MuiOutlinedInput-root': {
    paddingLeft: 8,
  },
  '.MuiOutlinedInput-input': {
    paddingLeft: 4,
  },
})

export const FormHelperText = styled(FormHelperTextMui)({
  textAlign: 'center',
})
